module.exports = __webpack_public_path__ + "img/file-doc.3d30443e.svg";